/**
 * T116: Copy Button Component
 * Button for copying text to clipboard with toast feedback
 */

import { useState } from 'react'
import { Copy, Check } from 'lucide-react'
import { Button, type ButtonProps } from '@/components/ui/button'

interface CopyButtonProps extends Omit<ButtonProps, 'onClick'> {
  text: string
  onCopy?: () => void
}

export function CopyButton({ text, onCopy, children, ...props }: CopyButtonProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      onCopy?.()
      setTimeout(() => setCopied(false), 2000)
    } catch (error) {
      console.error('Failed to copy:', error)
    }
  }

  return (
    <Button onClick={handleCopy} {...props}>
      {copied ? (
        <>
          <Check className="mr-2 h-4 w-4" />
          Copied!
        </>
      ) : (
        <>
          <Copy className="mr-2 h-4 w-4" />
          {children ?? 'Copy'}
        </>
      )}
    </Button>
  )
}
